"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react');


var _user = require('shared/selectors/user');
var _broadcastTemplateTokens = require('shared/services/broadcastTemplateTokens');
var _hooks = require('web/services/hooks');
var _variableDefault = require('web/screens/Broadcast/variableDefault');


var _columnPrefs = require('web/screens/Broadcast/CampaignPage/Body/MessagesTable/hooks/columnPrefs');















/* M8: one column per declared variable, in each user's order (G5, kept per
 * campaign in this browser). Rev 31 v2: the Columns menu is gone, so every
 * variable shows. */
const useRecipientColumns = (campaign) => {
  const { CampaignKey, TemplateFields, MessageTemplate } = campaign
  const userKey = _nullishCoalesce(_hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey), () => ( 'anonymous'))
  const storageKey = _columnPrefs.columnPrefsKey.call(void 0, userKey, CampaignKey)
  const [prefs, setPrefsState] = _react.useState(
    () => ({ key: storageKey, value: _columnPrefs.readColumnPrefs.call(void 0, storageKey) }),
  )
  const current = prefs.key === storageKey ? prefs.value : _columnPrefs.readColumnPrefs.call(void 0, storageKey)

  const names = _react.useMemo.call(void 0, () => TemplateFields.map(f => f.Name), [TemplateFields])
  const columns = _react.useMemo(
    () => {
      const tokens = _broadcastTemplateTokens.templateTokens.call(void 0, MessageTemplate)
      return _columnPrefs.arrangeColumns.call(void 0, names, current).map(name => {
        const ownDefault = _nullishCoalesce(_variableDefault.variableDefault.call(void 0, campaign, name), () => ( ''))
        const tokenFallback = _broadcastTemplateTokens.fallbackFor.call(void 0, tokens, name)
        return {
          name,
          fallback: _nullishCoalesce(tokenFallback, () => ( (ownDefault || null))),
          tokenFallback,
          ownDefault,
          isUsed: tokens.some(t => t.name === name),
        }
      })
    },
    [campaign, names, current, MessageTemplate],
  )

  const onMove = _react.useCallback.call(void 0, 
    (name, before) => setPrefsState(p => {
      const base = p.key === storageKey ? p.value : _columnPrefs.readColumnPrefs.call(void 0, storageKey)
      const value = { ...base, order: _columnPrefs.moveColumn.call(void 0, _columnPrefs.arrangeColumns.call(void 0, names, base), name, before) }
      _columnPrefs.writeColumnPrefs.call(void 0, storageKey, value)
      return { key: storageKey, value }
    }),
    [storageKey, names],
  )

  return { columns, onMove }
}

exports. default = useRecipientColumns
